module.exports = __webpack_public_path__ + "static/media/Upload.36dca80c.svg";